import webRootContext from "../components/webrootcontext/WebRootContext";

export async function getUserProfile() {
    
	var userProfileURL = webRootContext + "/rest/usermanagement/get/userProfile";
	
    return fetch(userProfileURL, {mode: "cors"})
        .then((response) => response.json())
}